/* eslint-disable */
import { api } from '@/api';
import { getStoreAccessors } from 'typesafe-vuex';
import { ActionContext } from 'vuex';
import { State } from '../state';
import {commitDeleteTask,commitSetPerformanceVersions, commitSetPipelineCheck,commitAddNotification, commitSetTasks, commitSetTask, commitSetTaskRecords, commitSetScripts, commitSetAccount, commitSetAccounts, commitDeleteAccount, commitUpdateAccount, commitSetPipelines, commitUpdatePipeline, commitDeletePipeline, commitSetTaskStatus, commitUpdateTask, commitSetPipelinePkgs, commitRunTask, commitSetSimpleScripts, commitUpdateScript, commitDeleteScript, commitSetScript, commitSetPipeline, commitSetSimpleTaskRecords, commitSetTaskStats, commitSetPipelinePkg, commitDeletePipelinePkg, commitSetRecordProject, commitDownloadPkg} from './mutations';
import { TaskState } from './state';
import { AxiosError } from 'axios';
import axios from 'axios';
import { ICopy,IAccount, IPipeline, IPipelinePkg, ISceneScriptCreate, IScript, ITask, ITaskControl } from '@/interfaces';
import { commitSetTaskRecord } from "./mutations";
import { ElMessage } from 'element-plus';
import { store } from '@/store';

type TaskContext = ActionContext<TaskState, State>;

export const actions = {
    async actionGetTaskRecord(context: TaskContext, payload: { record_id: any, project: any}) {
        try {
            //const response = await api.getTaskRecord(context.rootState.main.token, payload.project, payload.record_id);
            const config: any = {loading: false}
            const response = await axios.get(`/task/task_record/${payload.record_id}/?project=${payload.project}`, config);
            if (response.data) {
                commitSetTaskRecord(context, response.data);
            }
        } catch (error) {
          // await dispatchCheckApiError(context, error);
        }
      },
    async actionCheckApiError(context: TaskContext, payload: AxiosError) {
        if (payload.response!.status === 401) {
            // await dispatchLogOut(context);
        }
        if (payload.response!.status === 400 || payload.response!.status === 500) {
            commitAddNotification(context, { content: payload.message, color: 'error' });
        }
    },

    async actionGetTasks(context: TaskContext, payload: {project: number,page:number,size:number,task_name:string}) {
        try {
            const response = await api.getTasks(context.rootState.main.token, payload.project,payload.page,payload.size,payload.task_name);
            if (response.data) {
                commitSetTasks(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);

        }
    },
    async actionGetTaskRecordProject(context: TaskContext, payload: {task_record_id: number}) {
        try {
            const response = await api.getTaskRecordProject(context.rootState.main.token, payload.task_record_id);
            if (response.data) {
                commitSetRecordProject(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);

        }
    },
    async actionGetCustomTest(context: TaskContext) {
        try {
            const response = await api.getCustomTest(context.rootState.main.token);
            if (response.data) {
               return response.data
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);

        }
    },

    async actionGetTaskRecords(context: TaskContext, payload: {project: number}) {
        try {
            const response = await api.getTaskRecords(context.rootState.main.token, payload.project);
            if (response.data) {
                commitSetTaskRecords(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);

        }
    },

    async actionGetSimpleTaskRecords(context: TaskContext, payload: {project: number, task_name: string, task_status: number | "", create_user: string, page:number,size:number}) {
        try {
            const response = await api.getSimpleTaskRecords(context.rootState.main.token, payload.project, payload.task_name, payload.task_status, payload.create_user, payload.page,payload.size);
            if (response.data) {
                commitSetSimpleTaskRecords(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);

        }
    },

    async actionDeleteTask(context: TaskContext, payload: { id: number, project: number}) {
        try {
            const response = (await Promise.all([
                api.deleteTask(context.rootState.main.token, payload.id, payload.project),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitDeleteTask(context,  response.data);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async actionCreateTask(context: TaskContext, payload: ITask) {
        try {
            const response = (await Promise.all([
                api.createTask(context.rootState.main.token, payload),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitSetTask(context, response.data);
        } catch (error) {
            // if (error.response.status !== 409) {
            //     if (error.response.data.task_content) {
            //         alert(error.response.data.task_content)
            //     } else {
            //         alert(error.response.data)
            //     }
            // }
            await dispatchCheckApiError(context, error);
        }
    },
    async actionCopyData(context: TaskContext, payload: ICopy) {
        try {
            const response = (await Promise.all([
                api.copyTask(context.rootState.main.token, payload),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            
        } catch (error) {
            // if (error.response.status !== 409) {
            //     if (error.response.data.task_content) {
            //         alert(error.response.data.task_content)
            //     } else {
            //         alert(error.response.data)
            //     }
            // }
            await dispatchCheckApiError(context, error);
        }
    },

    async actionUpdateTask(context: TaskContext, payload: { id: number, task: ITask }) {
        try {
            const response = (await Promise.all([
                api.updateTask(context.rootState.main.token, payload.id, payload.task),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitUpdateTask(context, payload.task.project)
        } catch (error) {
            // if (error.response.status !== 409) {
            //     if (error.response.data.task_content) {
            //         alert(error.response.data.task_content)
            //     } else {
            //         alert(error.response.data)
            //     }
            // }
            await dispatchCheckApiError(context, error);
        }
    },


    async actionGetTest(context: TaskContext) {
        const payload: any = {
            title: {
            text: "ECharts 入门示例",
            },
            tooltip: {},
            xAxis: {
            data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"],
            },
            yAxis: {},
            series: [
            {
                name: "销量",
                type: "bar",
                data: [5, 20, 36, 10, 10, 20],
            },
            ],
        }
        // commitSetTest(context, payload);

    },

    // 获取全部common_taskstatus
    async actionGetTaskStatus(context: TaskContext, payload: {project: number}) {
        try {
        const response = await api.getTaskstatus(
            context.rootState.main.token,
            payload.project,
        );
        if (response.data) {
            commitSetTaskStatus(context, response.data);
        }
        } catch (error) {
        await dispatchCheckApiError(context, error);
        }
    },

    // 获取任务状态(任务从表：任务状态表)
    async actionGetTaskStats(context: TaskContext, payload: {project: number}) {
        try {
            const response = await api.getTaskStats(context.rootState.main.token, payload.project);
            if (response.data) {
                commitSetTaskStats(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);

        }
    },
    async actionGetPerformanceVersions(context: TaskContext, payload: {project: number}) {
        try {
            const response = await api.getPerformanceVersions(context.rootState.main.token, payload.project);
            if (response.data) {
                commitSetPerformanceVersions(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);

        }
    },
    async actionGetPerformanceVersionsCreate(context: TaskContext, payload: {project: number,version:string}) {
        try {
            const response = await api.getPerformanceVersionsCreate(context.rootState.main.token, payload);
            if (response.data) {
                return response.data
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);

        }
    },

    async actionRunTask(context: TaskContext, payload: ITaskControl) {
        try {
            const response = await api.runTask(context.rootState.main.token, payload);
            return response.data
        } catch (error) {
            await dispatchCheckApiError(context, error);
            return {data: error.response.data, status: error.response.status}
            // alert(error.response.data)
            
        }
    },
    async actionGetScripts(context: TaskContext, payload: {project: number, scene?: number | null,page:number,size:number,script_name:string}) {
        try {
            const response = await api.getScripts(context.rootState.main.token,  payload.project, payload.scene,payload.page,payload.size,payload.script_name);
            if (response.data) {
                commitSetScripts(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetScriptsContent(context: TaskContext, payload: {project: number, script_id: number}) {
        try {
            const response = await api.getScripts_content(context.rootState.main.token, payload.script_id, payload.project, );
            if (response.data) {
                return response.data
                // commitSetScripts(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetSimpleScripts(context: TaskContext, payload: {project: number, scene?: number | null}) {
        try {
            const response = await api.getSimpleScripts(context.rootState.main.token, payload.project, payload.scene);
            if (response.data) {
                commitSetSimpleScripts(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);

        }
    },
    async actionCreateScript(context: TaskContext, payload: IScript) {
        try {
            const response = (await Promise.all([
                api.createScript(context.rootState.main.token, payload),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitSetScript(context, response.data.project);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionCreateSceneScript(context: TaskContext, payload: ISceneScriptCreate) {
        try {
            const response = (await Promise.all([
                api.createSceneScript(context.rootState.main.token, payload),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitSetScript(context, {project:payload.project,page:payload.page,size:payload.size,script_name:payload.script_name});
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionCreateSceneScriptTop(context: TaskContext, payload: ISceneScriptCreate) {
        try {
            const response = (await Promise.all([
                api.createSceneScriptTop(context.rootState.main.token, payload),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
     if(response){
         return response.data
     }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionUpdateScript(context: TaskContext, payload: { script_id: number, script: IScript, project:number,page:number,size:number,script_name:string}) {
        try {
            const response = (await Promise.all([
                api.updateScript(context.rootState.main.token, payload.script_id, payload.script),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitUpdateScript(context, {project:payload.project,page:payload.page,size:payload.size,script_name:payload.script_name,});
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionDeleteScript(context: TaskContext, payload: { script_id: number, project: number,page:number,size:number,script_name:string}) {
        try {
            const response = (await Promise.all([
                api.deleteScript(context.rootState.main.token, payload.script_id, payload.project),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitDeleteScript(context, {project:payload.project,page:payload.page,size:payload.size,script_id:payload.script_id,script_name:payload.script_name});
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetAccounts(context: TaskContext, payload: {project: number}) {
        try {
            const response = await api.getAccounts(context.rootState.main.token, payload.project);
            if (response.data) {
                commitSetAccounts(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);

        }
    },

    async actionDeleteAccount(context: TaskContext, payload: { id: number, project: number}) {
        try {
            const response = (await Promise.all([
                api.deleteAccount(context.rootState.main.token, payload.id, payload.project),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitDeleteAccount(context, payload.id);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async actionCreateAccount(context: TaskContext, payload: IAccount) {
        try {
            const response = (await Promise.all([
                api.createAccount(context.rootState.main.token, payload),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitSetAccount(context, response.data);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async actionUpdateAccount(context: TaskContext, payload: { id: number, account: IAccount }) {
        try {
            const response = (await Promise.all([
                api.updateAccount(context.rootState.main.token, payload.account, payload.id),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitUpdateAccount(context, payload.account.project);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    
    async actionCreatePipeline(context: TaskContext, payload: IPipeline) {
        try {
            const response = (await Promise.all([
                api.createPipeline(context.rootState.main.token, payload),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitSetPipeline(context, response.data.project);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionGetPipelines(context: TaskContext, payload: {project: number}) {
        try {
            const response = await api.getPipelines(context.rootState.main.token, payload.project);
            if (response.data) {
                commitSetPipelines(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async actionUpdatePipeline(context: TaskContext, payload: { pipeline_key: string, pipeline: IPipeline }) {
        try {
            const response = (await Promise.all([
                // api.updatePipeline(context.rootState.main.token, payload.pipeline, payload.pipeline_key),
                api.updatePipeline(context.rootState.main.token, payload.pipeline),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitUpdatePipeline(context, payload.pipeline.project);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async actionDeletePipeline(context: TaskContext, payload: { pipeline_key: string, project: number}) {
        try {
            const response = (await Promise.all([
                api.deletePipeline(context.rootState.main.token, payload.pipeline_key, payload.project),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitDeletePipeline(context, payload.pipeline_key);
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },

    async actionGetPipelinePkgs(context: TaskContext, payload: {project: number, pipeline_id: string | null}) {
        try {
            const response = await api.getPipelinePkgs(context.rootState.main.token, payload.project, payload.pipeline_id);
            if (response.data) {
                commitSetPipelinePkgs(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
        async actionDownloadPkg(context: TaskContext, payload: {project: number, pipeline_download_id:any}) {
        try {
            const response = await api.downloadPkg(context.rootState.main.token, payload.project, payload.pipeline_download_id);
            if (response.data) {
                commitDownloadPkg(context, response.data);
            }
        } catch (error) {
            await dispatchCheckApiError(context, error);
        }
    },
    async actionPipeline(
        context: TaskContext,
        payload: {
          project: number;
          pipeline_id:string
        }
      ) {
        try {
          const response = await api.pipeline(
            context.rootState.main.token,
            payload.project,
            payload.pipeline_id
          );
          if (response.data) {
            commitSetPipelineCheck(context, response.data);
          }
        } catch (error: any) {
          await dispatchCheckApiError(context, error);
        }
      },

    async actionUpdatePipelinePkg(context: TaskContext, payload: IPipelinePkg) {
        try {
            const response = (await Promise.all([
                // api.updatePipeline(context.rootState.main.token, payload.pipeline, payload.pipeline_key),
                api.updatePipelinePkg(context.rootState.main.token, payload),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitSetPipelinePkg(context, (payload.project as any));
            ElMessage({
                showClose: true,
                message: '更新自动清理配置成功',
                type: 'success'
            });
        } catch (error) {
            // 请求失败重置配置
            await dispatchGetPipelinePkgs(store, {project: (payload.project as number), pipeline_id: null})
            ElMessage({
                showClose: true,
                message: '更新自动清理配置错误',
                type: 'error'
            });
            await dispatchCheckApiError(context, error);
        }
    },

    async actionDeletePipelinePkg(context: TaskContext, payload: IPipelinePkg) {
        try {
            const response = (await Promise.all([
                api.deletePipelinePkg(context.rootState.main.token, payload.id, (payload.project as number)),
                await new Promise<void>((resolve, reject) => setTimeout(() => resolve(), 500)),
            ]))[0];
            commitDeletePipelinePkg(context, payload.id);
            ElMessage({
                showClose: true,
                message: payload.filename + '安装包删除成功',
                type: 'success'
            });
        } catch (error) {
            // ElMessage({
            //     showClose: true,
            //     message: payload.filename + '安装包删除失败，请联系管理员查询原因',
            //     type: 'error'
            // });
            await dispatchCheckApiError(context, error);
        }
    },

};

const { dispatch } = getStoreAccessors<TaskState | any, State>('');

export const dispatchCheckApiError = dispatch(actions.actionCheckApiError);
// 任务
export const dispatchGetTasks = dispatch(actions.actionGetTasks);
export const dispatchDeleteTask = dispatch(actions.actionDeleteTask);
export const dispatchCreateTask = dispatch(actions.actionCreateTask);
export const dispatchCopyData = dispatch(actions.actionCopyData);
export const dispatchUpdateTask = dispatch(actions.actionUpdateTask);
export const dispatchGetTest = dispatch(actions.actionGetTest);
export const dispatchRunTask = dispatch(actions.actionRunTask);
export const dispatchGetTaskStatus = dispatch(actions.actionGetTaskStatus);
export const dispatchGetTaskStats = dispatch(actions.actionGetTaskStats);
export const dispatchGetPerformanceVersions = dispatch(actions.actionGetPerformanceVersions);
export const dispatchGetPerformanceVersionsCreate = dispatch(actions.actionGetPerformanceVersionsCreate);
// 任务记录
export const dispatchTaskRecords = dispatch(actions.actionGetTaskRecords);
export const dispatchSimpleTaskRecords = dispatch(actions.actionGetSimpleTaskRecords);
export const dispatchGetTaskRecord = dispatch(actions.actionGetTaskRecord);
// 场景脚本
export const dispatchGetScripts = dispatch(actions.actionGetScripts);
export const dispatchGetScriptsContent = dispatch(actions.actionGetScriptsContent);
export const dispatchGetSimpleScripts = dispatch(actions.actionGetSimpleScripts);
export const dispatchDeleteScript = dispatch(actions.actionDeleteScript);
export const dispatchUpdateScript = dispatch(actions.actionUpdateScript);
export const dispatchCreateScript = dispatch(actions.actionCreateScript);
export const dispatchCreateSceneScript = dispatch(actions.actionCreateSceneScript);
export const dispatchCreateSceneScriptTop = dispatch(actions.actionCreateSceneScriptTop);
// 账号
export const dispatchGetAccounts = dispatch(actions.actionGetAccounts);
export const dispatchDeleteAccount = dispatch(actions.actionDeleteAccount);
export const dispatchCreateAccount = dispatch(actions.actionCreateAccount);
export const dispatchUpdateAccount = dispatch(actions.actionUpdateAccount);
//流水线
export const dispatchCreatePipeline = dispatch(actions.actionCreatePipeline);
export const dispatchGetPipelines = dispatch(actions.actionGetPipelines);
export const dispatchUpdatePipeline = dispatch(actions.actionUpdatePipeline);
export const dispatchDeletePipeline = dispatch(actions.actionDeletePipeline);
export const dispatchGetPipelinePkgs = dispatch(actions.actionGetPipelinePkgs);
export const dispatchDownloadPkg = dispatch(actions.actionDownloadPkg);
export const dispatchUpdatePipelinePkg = dispatch(actions.actionUpdatePipelinePkg);
export const dispatchDeletePipelinePkg = dispatch(actions.actionDeletePipelinePkg);
export const dispatchGetTaskRecordProject = dispatch(actions.actionGetTaskRecordProject);
export const dispatchGetCustomTest = dispatch(actions.actionGetCustomTest);

export const dispatchPipeline= dispatch(
  actions.actionPipeline
);






